export function localizedCountryName(countryIsoCode_: string, languageIsoCode: string) {
  const countryIsoCode = countryIsoCode_.toUpperCase();

  return (
    new Intl.DisplayNames([languageIsoCode.toLowerCase(), "en"], { type: "region" }).of(countryIsoCode) ??
    countryIsoCode
  );
}
